import React from "react";

import classNames from "classnames";

class DeleteCard extends React.Component {
    state = {
        deleteLinkClicked: false
    };

    handleDeleteLinkClick = e => {
        e.preventDefault();

        this.state.deleteLinkClicked
            ? this.props.deleteCard()
            : this.renderDeleteButton();
    };

    renderDeleteButton() {
        this.setState({
            deleteLinkClicked: true
        });
    }

    render() {
        return (
            <li>
                <div className="delete-card-container">
                    {!this.props.isPro ? (
                        <a
                            href="#"
                            className={classNames("delete-card-link", {
                                confirm: this.state.deleteLinkClicked
                            })}
                            onClick={this.handleDeleteLinkClick}
                        >
                            Delete Card
                        </a>
                    ) : null}
                </div>
            </li>
        );
    }
}

export default DeleteCard;
